import moment from 'moment';

import store from './store';
import { withUnit } from './storeHelpers';

const getStartProgress = () => store.getters.startProgress;
const getEndProgress = () => store.getters.endProgress;
const getStartDate = () => store.state.startDate;
const getDueDate = () => store.state.dueDate;

const unitsPerDay = () => {
  const startProgress = getStartProgress();
  const endProgress = getEndProgress();
  const range = endProgress - startProgress;

  const startDate = moment(getStartDate()).hour(0).minute(0).seconds(0);
  const dueDate = moment(getDueDate()).hour(23).minute(59).seconds(59);

  if (dueDate.isBefore(startDate)) {
    return range; // to be done yesterday
  }

  const daysRemaining = (dueDate.diff(startDate, 'hours') + 1) / 24;
  const u = Math.ceil(range / daysRemaining);

  return u;
};

function taskList() {
  const startProgress = getStartProgress();
  const endProgress = getEndProgress();
  const increment = unitsPerDay();
  const startDate = getStartDate();

  let progress = startProgress;
  const currentDate = moment(startDate);

  const tasks = [];

  while (progress < endProgress) {
    // if next increment exceeds end of the book, increment to end of the book exactly
    if ((progress + increment) > endProgress) {
      progress = endProgress;
    } else {
      progress += increment;
    }

    tasks.push({
      name: `Read "${store.state.title}" to ${withUnit(progress, store.state.unit)}`,
      options: {
        due: currentDate.toDate(),
        tags: store.state.unit === 'percent' ? ['Equipment : Kindle'] : undefined,
      },
    });

    currentDate.add(1, 'days');
  }

  tasks.push({
    name: `Log "${store.state.title}" on Goodreads`,
    options: {
      flagged: true,
    },
  });

  return tasks;
}

export default {
  taskList,
};
